module.exports = __webpack_public_path__ + "img/dialoge_frame.df8e8f6e.png";